
class CountDown {
  startTime = new Date()
  timer: number | null = null
  time: number
  tipsBefore: number
  cb: Function | null = null
  countable = true

  constructor(time: number, tipsBefore: number) {
    this.time = time
    this.tipsBefore = tipsBefore
  }

  start(cb: Function) {
    this.startTime = new Date()
    this.countable = true
    this.cb = cb
    this.countDown()
  }

  clearTimer() {
    this.countable = false
    if (this.timer) {
      window.clearTimeout(this.timer)
      this.timer = null
    }
  }

  countDown() {
    if (this.countable) {
      const curTime = new Date()
      let duration = (curTime.getTime() - this.startTime.getTime()) / 1000

      if (this.tipsBefore > this.time) {
        this.tipsBefore = this.time
      }
  
      if (duration >= (this.time - this.tipsBefore)) {
        this.cb && this.cb()
        this.clearTimer()
      }

      if (this.countable) {
        this.timer = setTimeout(() => {
          this.countDown()
        }, 1000)
      }
    } else {
      this.clearTimer()
    }
  }
}

export default CountDown